import { PageController } from '@client/components/_core/layout/PageController';
import { ControlActivityEdit } from '@client/components/controls/control-activity-edit';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/controls/register/details/$id/activity/$activityId')({
    staticData: {
        presentation: 'overlay',
        ui: { useParentTitle: true },
    },
    params: {
        parse({ activityId }) {
            return { activityId: BigInt(activityId) };
        },
    },
    component: ControlActivityRoute,
});

function ControlActivityRoute() {
    const { id: controlId, activityId } = Route.useParams();
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { trpcUtils } = useTrpc();

    return (
        <PageController route={Route}>
            <ControlActivityEdit
                action={['edit', activityId, controlId]}
                onClose={async () => {
                    await trpcUtils.control.activity.invalidate();
                    navigate({
                        to: '/console/$orgId/controls/register/details/$id',
                        params: { orgId, id: controlId },
                        fromComponent: 'drawer',
                    });
                }}
            />
        </PageController>
    );
}
